import script from "./MissingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MissingPage.vue?vue&type=script&setup=true&lang=js"

import "./MissingPage.vue?vue&type=style&index=0&id=0c0e54be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c0e54be"]])

export default __exports__